module.exports = __webpack_public_path__ + "img/zwischenzeiten5.dac4959a.jpg";